import { Button, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { FormRow, FormWrapper, MapPickerWrapper, OperationWrapper, Title, TitleWrapper, UpdateDeviceInformationWrapper } from "./UpdateDeviceInformation.styled";
import DeviceApi from "../../../../../../../api/DeviceApi";
import MapPicker from "../../../../../../../components/ui-components/map-picker/MapPicker";
import GatewayApi from "../../../../../../../api/GatewayApi";

interface UpdateDeviceInformationProps {
    deviceView: any,
    onClose: ()=> void,
    onComplete: ()=> void,
}

export const UpdateDeviceInformation: React.FC<UpdateDeviceInformationProps> = (props)=> {
    let device = props.deviceView.device;

    // api
    let deviceApi = new DeviceApi();
    const [form] = Form.useForm();

    // state
    let [deviceInformation, setDeviceInformation] = useState<any>({
        id: device.id,
        nodeId: device.nodeId,
        name: device.name,
        deviceNo: device.deviceNo,
        gatewayPort: device.gatewayPort,
        slaveAddress: device.slaveAddress,
        positioningMethod: device.positioningMethod,
        geoLatitude: device.geoLatitude,
        geoLongitude: device.geoLongitude,
        remarks: device.remarks,
    });
    let [gatewayOptions, setGatewayOptions] = useState([]);
    let [gatewayPortOptions, setGatewayPortOptions] = useState<any[]>([]);
    let [submitEnabled, setSubmitEnabled] = useState(false);

    // function
    let loadGateways = async ()=> {
        let gatewayApi = new GatewayApi();
        let gatewayViews = (await gatewayApi.getAllGatewayViews()).data.data;
        gatewayOptions = gatewayViews.map((e)=> { return {label: e.gateway.name, value: e.gateway.nodeId, gatewayView: e}; })
        setGatewayOptions(gatewayOptions);
        onGatewayChange(deviceInformation.nodeId);
    };

    // validate
    let validateForm = ()=> {
        form.validateFields().then((values)=> {
            setSubmitEnabled(true);
        }).catch((err)=> {
            setSubmitEnabled(false);
            console.log(err);
        });
    };

    // events
    let onGatewayChange = async (gatewayNodeId)=> {
        deviceInformation.nodeId = gatewayNodeId;
        setDeviceInformation({...deviceInformation});
        validateForm();

        // update gateway port options
        let gatewayView = gatewayOptions.find((e)=> e.value==gatewayNodeId).gatewayView;
        if (!gatewayView) {
            return;
        }

        let product = gatewayView.product;
        let productSpecification = JSON.parse(product.specification);
        let productResources = productSpecification.productResources;
        let gatewayPortOptions = [];
        for (let productResource of productResources) {
            if (productResource.type == 'UART') {
                for (let i=1; i <= productResource.quantity; i++) {
                    let portName = 'UART-' + i
                    gatewayPortOptions.push({
                        label: portName,
                        value: portName
                    });
                }
            }
        }
        setGatewayPortOptions(gatewayPortOptions);

        // validate again
        validateForm();
    };

    let onDeviceNameChange = (e)=> {
        deviceInformation.name = e.target.value;
        setDeviceInformation({...deviceInformation});
        validateForm();
    };

    let onDeviceNoChange = (e)=> {
        deviceInformation.deviceNo = e.target.value;
        setDeviceInformation({...deviceInformation});
        validateForm();
    };

    let onGatewayPortChange = (value)=> {
        deviceInformation.gatewayPort = value;
        setDeviceInformation({...deviceInformation});
        validateForm();
    };

    let onSlaveAddressChange = (e)=> {
        deviceInformation.slaveAddress = e.target.value;
        setDeviceInformation({...deviceInformation});
        validateForm();
    }

    let onPositionMethodChange = (value)=> {
        deviceInformation.positioningMethod = value;
        setDeviceInformation({...deviceInformation});
        validateForm();
        setTimeout(()=> {
            validateForm();
        });
    };

    let onPick = (lng, lat)=> {
        deviceInformation.geoLatitude = lat;
        deviceInformation.geoLongitude = lng;
        setDeviceInformation({...deviceInformation});
        form.setFieldsValue(deviceInformation);
        validateForm();
    };

    let onRemarksChange = (e)=> {
        deviceInformation.remarks = e.target.value;
        setDeviceInformation({...deviceInformation});
        validateForm();
    };

    let onSubmit = async ()=> {
        await deviceApi.update({
            ...deviceInformation
        });
        props.onComplete();
        props.onClose();
    };

    let onCancel = ()=> {
        props.onClose();
    };

    // effect
    useEffect(()=> {
        if (props.deviceView.deviceTemplate.nodeType == 'SLAVE') {
            loadGateways();
        }
    }, []);

    // render
    let positionMethodOptions = [
        {
            label: '自动定位',
            value: 'AUTO',
        }, {
            label: '手动定位',
            value: 'MANUAL',
        },
    ];

    return (
        <UpdateDeviceInformationWrapper>
            <TitleWrapper>
                <Title>编辑设备</Title>
            </TitleWrapper>

            <FormWrapper>
                <Form form={form} name="form" layout="vertical">
                    <FormRow>
                        <Form.Item name="deviceTemplateName" label="设备模板" rules={[{required: true}]} initialValue={props.deviceView.deviceTemplate.name}>
                            <Input disabled={true}/>
                        </Form.Item>

                        { props.deviceView.deviceTemplate.nodeType == 'DIRECT' &&
                            <Form.Item name="nodeSn" label="设备序列号" rules={[{required: true}]} initialValue={props.deviceView.node.sn}>
                                <Input disabled={true}/>
                            </Form.Item>
                        }

                        { props.deviceView.deviceTemplate.nodeType == 'SLAVE' &&
                            <Form.Item name="nodeId" label="网关" rules={[{required: true}]} initialValue={deviceInformation.nodeId}>
                                <Select
                                    placeholder="请选择设备网关"
                                    onChange={onGatewayChange}
                                    options={gatewayOptions}
                                />
                            </Form.Item>
                        }
                    </FormRow>

                    <FormRow>
                        <Form.Item name="name" label="设备名称" rules={[{required: true}]} initialValue={deviceInformation.name}>
                            <Input onChange={onDeviceNameChange} />
                        </Form.Item>
                        <Form.Item name="deviceNo" label="设备编号" rules={[{required: true}]} initialValue={deviceInformation.deviceNo}>
                            <Input onChange={onDeviceNoChange} />
                        </Form.Item>
                    </FormRow>


                    {  props.deviceView.deviceTemplate.nodeType == 'SLAVE' && <FormRow>
                        <Form.Item name="gatewayPort" label="端口" rules={[{required: true}]} initialValue={deviceInformation.gatewayPort}>
                            <Select
                                placeholder="请选择端口"
                                onChange={onGatewayPortChange}
                                options={gatewayPortOptions}
                            />
                        </Form.Item>

                        <Form.Item name="slaveAddress" label="从机地址" rules={[{required: true}]} initialValue={deviceInformation.slaveAddress}>
                            <Input onChange={onSlaveAddressChange} />
                        </Form.Item>
                    </FormRow>}

                    <FormRow>
                        <Form.Item name="positioningMethod" label="定位方式" rules={[{required: true}]} initialValue={deviceInformation.positioningMethod} style={{flex: '2 2 0px'}}>
                            <Select
                                placeholder="请选择定位方式"
                                onChange={onPositionMethodChange}
                                options={positionMethodOptions}
                            />
                        </Form.Item>

                        {deviceInformation.positioningMethod === 'MANUAL' &&
                            <Form.Item name="geoLongitude" label="经度" rules={[{required: true}]} initialValue={deviceInformation.geoLongitude}>
                                <Input disabled={true} value={deviceInformation.geoLongitude}/>
                            </Form.Item>
                        }
                        {deviceInformation.positioningMethod === 'MANUAL' &&
                            <Form.Item name="geoLatitude" label="纬度" rules={[{required: true}]} initialValue={deviceInformation.geoLatitude}>
                                <Input disabled={true} value={deviceInformation.geoLatitude}/>
                            </Form.Item>
                        }
                    </FormRow>

                    {deviceInformation.positioningMethod === 'MANUAL' && <FormRow>
                        <MapPickerWrapper>
                            <MapPicker lng={deviceInformation.geoLongitude} lat={deviceInformation.geoLatitude} onPick={onPick} />
                        </MapPickerWrapper>
                    </FormRow>
                    }

                    <Form.Item name="remarks" label="备注" rules={[{required: false}]} initialValue={deviceInformation.remarks}>
                        <Input.TextArea style={{height: '50px'}} onChange={onRemarksChange}/>
                    </Form.Item>
                </Form>
            </FormWrapper>

            <OperationWrapper>
                <Space size="middle">
                    <Button type="primary" disabled={!submitEnabled} onClick={onSubmit}>确定</Button>
                    <Button type="primary" danger onClick={onCancel}>取消</Button>
                </Space>
            </OperationWrapper>
        </UpdateDeviceInformationWrapper>
    );
};

export default UpdateDeviceInformation;
